<template>
  <div>
    <b-row>
      <b-col>
        <b-checkbox
          id="service-agreement-checkbox"
          v-model="localValue"
          size="lg"
        >
          <h6 style="margin-top:5px">
            I accept the
            <b-link @click="downloadDocument">Terms of Service</b-link>
          </h6>
        </b-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Storage } from "aws-amplify";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    documentPath: {
      type: String,
      default: "",
      required: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    }
  },
  methods: {
    async downloadDocument() {
      try {
        const fileLink = await Storage.get(this.documentPath);
        window.open(fileLink);
      } catch (e) {
        this.$logger.error(`Error retrieving service agreement: ${doc}`);
        this.$logger.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
